import { render, staticRenderFns } from "./news_page.vue?vue&type=template&id=4f872cf0&scoped=true&"
import script from "./news_page.vue?vue&type=script&lang=js&"
export * from "./news_page.vue?vue&type=script&lang=js&"
import style0 from "./news_page.vue?vue&type=style&index=0&id=4f872cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f872cf0",
  null
  
)

export default component.exports